import { handleErrors } from '.';

import type { MemoryDataForm } from '../types/forms/memorydataform';
import type { ShareFormData } from '../types/forms/shareform';

interface MemoryAPIParams {
  page?: number;
  per_page?: number;
  search?: string;
  user_id?: string;
  timeline_id?: string;
  not_in_timeline_id?: string;
};

export const APIcreateMemory = async (data: MemoryDataForm) => (
  window.axios.post('/api/memories', data)
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIfetchMemories = async (params: MemoryAPIParams = {}) => (
  window.axios.get('/api/memories?variant=memory', { params })
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);

export const APIfetchSprks = async (params: MemoryAPIParams = {}) => (
  window.axios.get('/api/memories?variant=sprk', { params })
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);

export const APIfetchReceivedMemories = async (params: MemoryAPIParams = {}) => (
  window.axios.get('/api/memories/received?variant=memory', { params })
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);

export const APIfetchReceivedSprks = async (params: MemoryAPIParams = {}) => (
  window.axios.get('/api/memories/received?variant=sprk', { params })
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);

export const APIfetchMemory = async (memoryId: string, params: MemoryAPIParams = {}) => (
  window.axios.get(`/api/memories/${memoryId}`, { params })
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);

export const APIfetchMemoryShares = async (memoryId: string) => (
  window.axios.get(`/api/memories/${memoryId}/shares`)
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);

export const APIdeleteMemory = async (memoryId: string) => (
  window.axios.delete(`/api/memories/${memoryId}`)
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIupdateMemory = async (memoryId: string, data: MemoryDataForm) => (
  window.axios.patch(`/api/memories/${memoryId}`, data)
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIsetMemoryReaction = async (memoryId: string, reactionId: number) => (
  window.axios.post(`/api/memories/${memoryId}/reactions`, { reaction_id: reactionId })
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIfetchMemoryComments = async (memoryId: string) => (
  window.axios.get(`/api/memories/${memoryId}/comments`)
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);

export const APIshareMemory = async (memoryId: string, data: ShareFormData) => (
  window.axios.post(`/api/memories/${memoryId}/shares`, data)
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIregisterMemoryView = async (memoryId: number, timelineId?: number) => (
  window.axios.post(`/api/memories/${memoryId}/views`, { timeline_id: timelineId })
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);
